import { render, staticRenderFns } from "./AddAttrebutes.vue?vue&type=template&id=d204301a&scoped=true&"
import script from "./AddAttrebutes.vue?vue&type=script&lang=js&"
export * from "./AddAttrebutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d204301a",
  null
  
)

export default component.exports